const Process = () => {
  const steps = [
    {
      title: "1. Inquiry",
      description:
        "Customer sends requirements via email, phone, or the website form. Our team reviews the request and confirms specifications.",
      icon: "📩",
    },
    {
      title: "2. Quotation",
      description:
        "Based on quantity, material, and delivery timeline, we provide a competitive quotation and estimated lead time.",
      icon: "📚",
    },
    {
      title: "3. Order Confirmation",
      description:
        "Upon approval, we confirm the order and initiate sourcing or manufacturing. Advance payment terms may apply.",
      icon: "✅",
    },
    {
      title: "4. Customization & Packaging",
      description:
        "If required, we plate, label, or custom-pack the products (e.g. station-wise sorting, corrosion protection).",
      icon: "📦",
    },
    {
      title: "5. Dispatch & Delivery",
      description:
        "Products are packed and shipped via reliable logistics partners across India. Tracking & delivery updates are provided.",
      icon: "🚚",
    },
    {
      title: "6. Support & Feedback",
      description:
        "We ensure after-sales support and welcome customer feedback for continuous improvement.",
      icon: "📞",
    },
  ];

  return (
    <section className="bg-gray-100 py-16 text-gray-800">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-2">Our Process</h1>
          <p className="text-gray-600 text-lg">
            A clear, customer-friendly journey from inquiry to delivery
          </p>
        </div>

        {/* Step-by-Step */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition duration-300"
            >
              <div className="text-4xl mb-3">{step.icon}</div>
              <h2 className="text-xl font-semibold mb-2">{step.title}</h2>
              <p className="text-gray-700 text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="/contact"
            className="inline-block bg-navy hover:navy-dark text-white px-6 py-3 rounded text-lg"
          >
            📞 Request a Quote
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
